import * as basicLightbox from 'basiclightbox';
import { WindowHelper } from '../WindowHelper';
import LightboxNavigation from './lightbox-navigation';

export default class Lightbox extends LightboxNavigation {
    setLightBoxClass(imageNode) {
        imageNode.classList.add('has-lightbox');
    }

    getImageParam(imageNode) {
        return {
            tmpSrc: imageNode.getAttribute('src'),
            tmpAlt: imageNode.getAttribute('alt'),
        };
    }

    forgeLightBoxItem(imageNode) {
        return `<img src="${this.getImageParam(imageNode).tmpSrc}" alt="${this.getImageParam(imageNode).tmpAlt}" style="max-width:85vw; max-height:85vh">`;
    }

    setLightBox() {
        for (let i = 0; i < this.allLightBoxableImg.length; i++) {
            this.setLightBoxClass(this.allLightBoxableImg[i]);
            this.allLightBoxableImg[i].addEventListener('click', () => {
                basicLightbox.create(this.forgeLightBoxItem(this.allLightBoxableImg[i])).show();
            });
        }
    }

    initLightBox() {
        this.allLightBoxableImg = document.querySelectorAll(this.imagesSelectors);
        this.setLightBox();
    }

    constructor() {
        super();
        this.imagesSelectors = '.page-header figure picture img, .is-gallery-item picture img, .image-same-height-and-contained figure picture img, .atelier-gallery-item picture img, .news .right picture img';
        if (WindowHelper.isElementThere(this.imagesSelectors)) this.initLightBox();
    }
}
